import React from "react";

type ContextType = {
  indexKey: number;
  listLength: number;
  arrowDownIcon: string;
  arrowUpIcon: string;
  arrowLeftRed: string;
};
const CardContext = React.createContext<ContextType>({
  indexKey: 0,
  listLength: 0,
  arrowUpIcon:'',
  arrowDownIcon:'',
  arrowLeftRed:'' 
});

export default CardContext;
